import React, { useMemo } from 'react';
import { WithLoadingComponent } from 'components/shared';
import { ReportingService } from "services/http";
import { FlexLoader } from 'components/pages/analytics-page/dashboard/dimensions-filter';
import Utils from "utils";

export const RecapKpis = (props) => {

    let { data } = props;
    //TO BE RETURNED FROM BACKEND
    data[0]["icon"] = "bi bi-inboxes-fill";
    data[1]["icon"] = "bi bi-person-check-fill";
    data[2]["icon"] = "bi bi-chat-right-text-fill";
    data[3]["icon"] = "bi bi-chat-text-fill";//"bi bi-chat-left-text-fill";

    return (
        <div className="m-4" style={styledRecapContainer}>
            {data.map(item => <KpiItem {...item} />)}
        </div>
    );
}

export const KpiItem = (props) => {

    const { icon, dataName, dataValue } = props;

    return (
        <div className="d-flex mx-3 my-2 w-25">
            <span className="mx-3 my-2 px-2 py-1" style={styledKpiIcon}>
                <i className={icon} style={{ fontSize: "20px", color: "#4DADD9" }} />
            </span>
            <div className="d-block">
                <span>{dataName}</span><br />
                <strong style={{ color: "#4DADD9" }}>{dataValue}</strong>
            </div>
        </div>
    )
}

const styledKpiIcon = {
    backgroundColor: "white",
    borderRadius: "5px",
    border: "0.1px solid #4DADD9",
};

const styledRecapContainer = {
    backgroundColor: "aliceblue",
    borderRadius: "10px",
    display: "flex"
}


export const RecapKpisHoc = () => {
    const filterSearchParam = JSON.parse(new URLSearchParams(window.location.search).get("filter"));
    const RecapHoc = useMemo(() => WithLoadingComponent(RecapKpis, () => ReportingService.getGlobalStats(Utils.buildFilterCriteria(filterSearchParam)), <FlexLoader />)(), [filterSearchParam?.startDate, filterSearchParam?.endDate]);
    return <RecapHoc />
}